import React, { useEffect } from "react";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import {Actions} from "../../../core/modules/Actions";
import { TopTab } from "../../../component/atom";
import { connect } from "react-redux";
import { Profile, Changepassword } from "../../../component/organism";
import HeadingComponent from "../../../component/atom/Headings/Heading";
const list = [
    {
        value: 0,
        label: 'My profile'
    },
    {
        value: 1,
        label: 'Password Settings'
    }
]

const ProfileScreen = ({ currentUser,  getUserData , verifyToken}) => {

    const [value, setValue] = React.useState(0)
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        getUserData();
    }, []);

    return (
        <Box className="main-screen-container">
       <Grid mt={'30px'} container >
       <HeadingComponent text={"Profile"} fontweigth={600} size={26} fontfamily={"Montserrat"} />
       </Grid>
            <Grid container >
                <Grid mt={'15px'} item xs={12}>
                    <div className={"tabSpace"}>
                        <TopTab tabList={list} onButtonPress={handleChange} value={value} />
                    </div>
                </Grid>
           
            {value == 0 ? <Profile /> :
                <Changepassword />}
                 </Grid>
        </Box>
    )
};

export default connect(
    state => ({
        currentUser: state.profile.get('currentUser')
    }),
    {
        getUserData: Actions.profile.getUserData,
        verifyToken: Actions.auth.verifyToken
    }
)(ProfileScreen);